import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/about-ripple.png'
import _imports_1 from '../../images/shell-blue-bg.png'
import _imports_2 from '../../images/about-company-bg.png'
import _imports_3 from '../../images/bg-net.png'
import _imports_4 from '../images/tab-2-section-2-3.png'
import _imports_5 from '../images/tab-2-section-4-1.png'


const _withScopeId = n => (_pushScopeId("data-v-162d5e20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "bg-image d-none d-md-block"
}, null, -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"title-wrapper\" data-v-162d5e20><div class=\"image-wrapper\" data-v-162d5e20><img src=\"" + _imports_1 + "\" class=\"icon\" data-v-162d5e20></div><div class=\"strong\" data-v-162d5e20> 다양한 해양 쓰레기 종류 </div></div><div class=\"text-wrapper\" data-v-162d5e20><div data-v-162d5e20>그렇다면 해양 쓰레기는 무엇일까요?</div><div data-v-162d5e20>해양 쓰레기는 육지에서 바다로 유입되는<br class=\"d-block d-md-none\" data-v-162d5e20> 폐기물과 바다에서<br class=\"d-none d-md-block\" data-v-162d5e20> 버려진 쓰레기 모두를 포함해요.</div></div>", 2)
const _hoisted_7 = { class: "scroll-x d-block d-md-none" }
const _hoisted_8 = { class: "d-inline-flex" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "blue section-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "bg-image bg-wave d-none d-md-block"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "bg-image bg-net d-none d-md-block"
}, null, -1))
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "content-wrapper" }
const _hoisted_16 = { class: "title-wrapper" }
const _hoisted_17 = { class: "image-wrapper" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "strong" }, " 다양한 해양 쓰레기 종류 ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "section-image"
}, null, -1))
const _hoisted_20 = { class: "yellow section-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "bg-image d-none d-md-block"
}, null, -1))
const _hoisted_22 = { class: "container" }
const _hoisted_23 = { class: "content-wrapper" }
const _hoisted_24 = { class: "title-wrapper" }
const _hoisted_25 = { class: "image-wrapper" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "strong" }, [
  /*#__PURE__*/_createTextVNode(" 일상생활 속"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 플라스틱 쓰레기 줄이기 ")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", null, "이런 문제점들을 해결하기 위해서"),
  /*#__PURE__*/_createElementVNode("div", null, "우리가 할 수 있는 것들을 하나씩 실천해 봐요!")
], -1))
const _hoisted_28 = { class: "section-4" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "bg-image d-none d-md-block"
}, null, -1))
const _hoisted_30 = { class: "container" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "section-image"
}, null, -1))
const _hoisted_32 = { class: "next-button-wrapper" }

import { onMounted } from 'vue';
  import TabTitle from './academy-title.vue';
  import Swiper from './swiper.vue';
  import SectionNavbar from './tab-2-sub-tab.vue';
  import NextButton from './next-button.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const images = [
    { url: require('../images/banner-1-1.png'), text: '해변 · 해안쓰레기' },
    { url: require('../images/banner-1-2.png'), text: '부유 쓰레기<br>(해수면 가까이 떠 있는 쓰레기)' },
    { url: require('../images/banner-1-3.png'), text: '해저 · 침적 쓰레기<br>(바다 밑에 가라앉은 쓰레기)' },
  ];

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TabTitle, {
          title: "해양 쓰레기, 읽어보기",
          step: "STEP 02."
        }),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(images, (item, index) => {
                return _createElementVNode("div", {
                  key: index,
                  class: "item"
                }, [
                  _createElementVNode("img", {
                    src: item.url,
                    class: "image"
                  }, null, 8, _hoisted_9),
                  _createElementVNode("div", {
                    class: "text-center",
                    innerHTML: item.text
                  }, null, 8, _hoisted_10)
                ])
              }), 64))
            ])
          ]),
          _createVNode(Swiper, {
            class: "d-none d-md-block",
            images: images
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _hoisted_12,
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item) => {
                return _createElementVNode("img", {
                  key: item,
                  src: _imports_1,
                  class: "icon"
                })
              }), 64))
            ]),
            _hoisted_18
          ]),
          _createVNode(SectionNavbar)
        ]),
        _hoisted_19
      ])
    ]),
    _createElementVNode("section", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
                return _createElementVNode("img", {
                  key: item,
                  src: _imports_1,
                  class: "icon"
                })
              }), 64))
            ]),
            _hoisted_26
          ]),
          _hoisted_27,
          _createVNode(Swiper, {
            images: [
            { url: require('../images/tab-2-section-3-1.jpg'), text: '제품 오래 사용하기' },
            { url: require('../images/tab-2-section-3-2.jpg'), text: '포장재를 줄인 제품 사용하기<br>(과대포장 제품 구입 X, 리필 스테이션 이용하기)' },
            { url: require('../images/tab-2-section-3-3.jpg'), text: '올바른 분리배출 하기' },
            { url: require('../images/tab-2-section-3-4.jpg'), text: '1회용품 사용 안 하기' },
            { url: require('../images/tab-2-section-3-5.jpg'), text: '깨끗하고 아름다운 우리 바다를 지키기 위한<br>‘가져와요 플라스틱! 지켜가요 우리바다!’ 활동 참여하기' },
          ]
          }, null, 8, ["images"])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_28, [
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createVNode(NextButton)
        ])
      ])
    ])
  ], 64))
}
}

})